// split-test: resource_show_modal_view

import { triggerCustomEvent, getKeyByValue } from 'lib/helpers';
import { getAjaxModal } from 'lib/ajax-helpers';
import { fetchState, setState } from 'lib/state-helpers';
import Cookies from 'js-cookie';
import events from 'lib/events';

const openModalFromHistory = (modalData) => {
  triggerCustomEvent(events.show_page.modal.update_resource_navigation_context, {
    newCurrentPath: modalData.path,
  });

  triggerCustomEvent(events.show_page.modal.reload_modal_view);

  const navContext = modalData.navContext || fetchState('resources-nav-context');
  setState('resources-nav-context', navContext);

  window.history.replaceState({
    modalData: {
      id: 'resource-show-modal-view',
      title: modalData.title,
      path: modalData.path,
      contextPath: document.body.getAttribute('data-referring-path'),
      navContext,
    },
  }, modalData.title, modalData.path);

  getAjaxModal(modalData.path, null, null, { history_click: true });
};

const openModalInPreviousContext = (modalData) => {
  Cookies.set('open-modal-show-on-page-load', modalData);

  window.history.replaceState({
    modalData: {
      id: 'resource-show-modal-view',
      title: modalData.title,
      path: modalData.path,
      contextPath: modalData.contextPath,
    },
  }, modalData.title, modalData.contextPath);

  window.history.go(modalData.contextPath);
};

const restoreModalView = (modalData, referringPath) => {
  if (referringPath !== modalData.contextPath) {
    openModalInPreviousContext(modalData);
  } else {
    openModalFromHistory(modalData);
  }
};

const historyState = (event, referringPath) => {
  if (event.state.modalData) {
    restoreModalView(event.state.modalData, referringPath);
  } else if (document.querySelector('#resource-show-modal-view')) {
    triggerCustomEvent(events.show_page.modal.history_close_modal_view);
  }
};

if (Cookies.get('open-modal-show-on-page-load')) {
  openModalFromHistory(JSON.parse(Cookies.get('open-modal-show-on-page-load')));

  Cookies.remove('open-modal-show-on-page-load');
}

window.addEventListener('popstate', (event) => {
  if (event.state && Object.entries(event.state).length > 0 && !event.state.turbolinks) {
    historyState(event, document.body.getAttribute('data-referring-path'));
  } else if (document.querySelector('#resource-show-modal-view')) {
    triggerCustomEvent(events.show_page.modal.history_close_modal_view, { updateState: false });
  } else {
    window.history.go(document.location);
  }
});

window.addEventListener(events.show_page.modal.build_resource_navigation_context, (event) => {
  const { targetResourcePath } = event.detail;

  const gridContainer = event.detail.targetResourceGroup;
  const gridItems = [...gridContainer.querySelectorAll('.ez-resource-thumb__link')];

  const resourcesNavContext = {};

  gridItems.forEach((item, index) => {
    resourcesNavContext[index] = item.getAttribute('href');
  });

  resourcesNavContext.currentPosition = getKeyByValue(resourcesNavContext, targetResourcePath);

  setState('resources-nav-context', resourcesNavContext);
});
